export var ValueUtil;
(function (ValueUtil) {
    /**
     * 値がない場合、true
     * @param value
     */
    function isEmpty(value) {
        if (value == null) {
            return true;
        }
        const typeName = Object.prototype.toString.call(value);
        switch (typeName) {
            case "[object String]":
                if (value === "") {
                    return true;
                }
                break;
            case "[object Array]":
                if (value.length === 0) {
                    return true;
                }
                break;
        }
        return false;
    }
    ValueUtil.isEmpty = isEmpty;
    /**
     * 変更されている場合、true
     * @param value1
     * @param value2
     */
    function isChange(value1, value2) {
        if (value1 === value2) {
            return false;
        }
        else {
            if (isEmpty(value1) && isEmpty(value2)) {
                return false;
            }
            return true;
        }
    }
    ValueUtil.isChange = isChange;
    /**
     * checkValue が null の時、returnValueForNull
     * @param checkValue
     * @param returnValueForNull
     */
    function nvl(checkValue, returnValueForNull = '', returnValueForNotNull = null) {
        if (checkValue == null) {
            // null の時
            if (typeof returnValueForNull === 'function') {
                return returnValueForNull();
            }
            else {
                return returnValueForNull;
            }
        }
        else {
            // nullじゃない時
            if (returnValueForNotNull == null) {
                return checkValue;
            }
            else {
                if (typeof returnValueForNotNull === 'function') {
                    return returnValueForNotNull();
                }
                else {
                    return returnValueForNotNull;
                }
            }
        }
    }
    ValueUtil.nvl = nvl;
})(ValueUtil || (ValueUtil = {}));
